var _path, _g, _path2, _path3, _g2, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRealcityLogoSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_937_3024",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 12,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.21448H11.8962V30.4986H0V3.21448Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_937_3024)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.44782 30.4986C6.22711 30.4986 6.00923 30.4365 5.81958 30.317C5.55088 30.1476 5.36264 29.8765 5.29676 29.5659L0.0256986 4.63415C-0.0495955 4.28026 0.0426398 3.91132 0.27511 3.63462C0.507581 3.35744 0.85911 3.20591 1.21582 3.21485L6.0544 3.37768C6.70335 3.39979 7.21252 3.94379 7.1904 4.5932C7.16876 5.24262 6.62617 5.7565 5.97535 5.7292L2.6384 5.61673L7.34899 27.8958L10.445 27.1523C11.0756 26.9984 11.7118 27.389 11.8633 28.021C12.0153 28.6525 11.6262 29.2883 10.9946 29.4398L6.72264 30.4661C6.63182 30.4883 6.53958 30.4986 6.44782 30.4986Z",
    fill: "#7F7F7F"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6906 27.3795C20.1631 27.3795 19.6831 27.0219 19.5499 26.4873C19.3927 25.8567 19.7767 25.2181 20.4073 25.061L21.5847 24.7678L20.5226 6.50567L16.1353 6.35225C15.4859 6.32967 14.9781 5.78472 15.0007 5.13531C15.0238 4.48637 15.5626 3.97814 16.2177 4.00072L21.6755 4.19131C22.2826 4.21249 22.7739 4.69249 22.8087 5.29908L23.9904 25.605C24.0233 26.1701 23.6497 26.6784 23.1005 26.8153L20.9758 27.3443C20.8803 27.3683 20.7847 27.3795 20.6906 27.3795Z",
    fill: "#7F7F7F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_937_3024",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 1,
    width: 8,
    height: 8
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.39771 1.14917H14.4978V8.24842H7.39771V1.14917Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_937_3024)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9501 3.50208C10.8757 3.50208 10.8005 3.50913 10.7261 3.52325C10.0781 3.64513 9.64986 4.27149 9.77174 4.91996C9.89174 5.55902 10.5237 5.99619 11.1685 5.87431C11.8169 5.75243 12.2452 5.12608 12.1233 4.4776C12.0169 3.91243 11.5233 3.50208 10.9501 3.50208ZM10.9445 8.2484C9.24045 8.2484 7.77457 7.03146 7.45928 5.35476C7.09739 3.43146 8.36798 1.57217 10.2917 1.21076C10.5087 1.16981 10.7303 1.14911 10.9501 1.14911C12.6541 1.14911 14.12 2.36605 14.4357 4.04229C14.6108 4.97452 14.4127 5.91852 13.8776 6.70111C13.3426 7.4837 12.535 8.0117 11.6033 8.18676C11.3863 8.2277 11.1647 8.2484 10.9445 8.2484Z",
    fill: "#7F7F7F"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5519 26.353C15.4776 26.353 15.4023 26.3605 15.3279 26.3741C14.6799 26.496 14.2517 27.1228 14.374 27.7713C14.494 28.4099 15.1246 28.8485 15.7707 28.7252C16.0846 28.6664 16.3566 28.4885 16.5373 28.225C16.7176 27.961 16.7844 27.6428 16.7251 27.3285C16.6187 26.7633 16.1256 26.353 15.5519 26.353ZM15.5467 31.0993C13.8423 31.0993 12.3764 29.8824 12.0616 28.2061C11.6997 26.2828 12.9703 24.4231 14.8936 24.0616C15.1105 24.0207 15.3322 24 15.5519 24C17.2564 24 18.7218 25.2169 19.0376 26.8936C19.2126 27.8254 19.0145 28.7694 18.4799 29.5525C17.9449 30.3351 17.1373 30.8626 16.2056 31.0376C15.9882 31.0786 15.7665 31.0993 15.5467 31.0993Z",
    fill: "#7F7F7F"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealcityLogoSmall);
export default __webpack_public_path__ + "static/media/realcity_logo_small.98cd93a7d757f13c847ddd0927f322ea.svg";
export { ForwardRef as ReactComponent };